import type {SxProps} from '@mui/material';
import TextField from '@mui/material/TextField';
import {lighten} from '@mui/system/colorManipulator';
import type {ChangeEvent, FC, ReactNode} from 'react';
import {secondaryColor} from '@/theme/theme';

//TYPES
type Props = {
  label?: string;
  size?: 'small' | 'medium';
  value?: string;
  placeholder?: string;
  required?: boolean;
  multiline?: boolean;
  startAdornment?: ReactNode;
  onChange: (value: string) => void;
  direction?: 'column' | 'row';
  type?: 'text' | 'password';
};

const InputText: FC<Props> = ({
  value,
  size = 'small',
  onChange,
  placeholder,
  required = false,
  multiline = false,
  startAdornment,
  type = 'text',
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value);

  return (
    <TextField
      size={size}
      variant="outlined"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      fullWidth
      type={type}
      multiline={multiline}
      rows={4}
      slotProps={{input: {startAdornment}}}
      sx={styles.textField}
    />
  );
};
export default InputText;

const styles: Record<string, SxProps> = {
  textField: {
    width: '100%',
    mb: 1,
    bgcolor: lighten(secondaryColor, 0.95),
    '& .MuiOutlinedInput-root': {
      borderRadius: '0px',
      flex: 1,
      '&:hover fieldset': {
        borderRadius: '0px',
        borderColor: 'primary.main', // borde hover
      },
      '&.Mui-focused fieldset': {
        borderColor: 'secondary.main', // borde focus
      },
    },
  },
};
